import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import AuthService from '@/services/auth/auth.service';
import UserService from '@/services/user/user.service';

export const useUsers = () => {
  return useQuery({
    queryKey: ['users'],
    queryFn: UserService.getAll,
  });
};

export const useUser = ({ id, enabled = true }: { id: number; enabled?: boolean }) => {
  return useQuery({
    queryKey: ['users', id],
    queryFn: () => UserService.getById(id),
    enabled,
  });
};

export const getUserOptions = queryOptions({
  queryKey: ['auth'],
  queryFn: AuthService.getMe,
  staleTime: Infinity,
});

export const useGetUser = () => {
  const query = useQuery(getUserOptions);
  const { data, isSuccess, isError } = query;

  useEffect(() => {
    if (isSuccess && data?.user) {
      Sentry.setUser({
        id: data.user.id?.toString(),
        username: data.user.username,
      });

      Sentry.setContext('user_profile', {
        fullName: `${data.user.firstName} ${data.user.lastName}`,
      });
    }

    if (isError) {
      Sentry.setUser(null);
      Sentry.setContext('user_profile', null);
    }
  }, [isSuccess, isError, data?.user]);

  return query;
};
